module.exports = __webpack_public_path__ + "static/img/product1.0ba916b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/hardProduct/images/phone/product1.png
// module id = Vo04
// module chunks = 1